import React from "react";
import { IconProps } from "../icon";

export const Map_01Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 18l-7 4V6l7-4m0 16l7 4m-7-4V2m7 20l6-4V2l-6 4m0 16V6m0 0L9 2"
    />
  </svg>
);
